import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { ADD_CUSTOMER } from "../apollo/mutations";
import closeModal from "../common/closeModal";
import { getCities, getCountries, getStates } from "../utils/country";
import { showSwal } from "../utils/swal";
import {
  getSelectedStoreDetails,
  payloadValidator,
} from "../utils/helperFunctions";
import { decryptData } from "../utils/encryptData";
import { GENERAL } from "../utils/encryptedConstants.";
import { SESSION_STORAGE } from "../common/masterEnums";

const defaultValues = {
  full_name: "",
  email: "",
  phone: "",
  balance: "0",
  user_id: "",
  walk_in: false,
  business: {
    name: "",
    type: "",
    ein_number: "",
    license_expiry: "",
    license_no: "",
    address: {
      address: "",
      country: {
        country_id: "US",
        label: "🇺🇸 United States",
        value: "United States",
      },
      city: "",
      state: "",
      zip: "",
    },
  },
};

const useCreateCustomer = (refetch) => {
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues });

  const general = decryptData(GENERAL, SESSION_STORAGE);

  const [submit] = useMutation(ADD_CUSTOMER);

  const onAddCustomer = async (data) => {
    try {
      console.log("data", data)
      const { business, full_name, email, phone, balance, user_id, walk_in } =
        data || {};

      const businessFields = {
        name: business?.name ?? null,
        type: business?.type ?? null,
        address: {
          address: business?.address?.address ?? "",
          city: business?.address?.city.value ?? "",
          state: business?.address?.state.value ?? "",
          country: business?.address?.country.value ?? "",
          zip: business?.address?.zip ?? "",
        },
        license: business?.license ?? null,
        ein_number: business?.ein_number == "" ? null : business?.ein_number,
        license_expiry:
          business?.license_expiry == "" ? null : business?.license_expiry,
        license_no: business?.license_no == "" ? null : business?.license_no,
      };

      const payload = {
        full_name: full_name ?? "",
        email: email === "" ? null : email,
        phone: phone ?? "",
        user_id: user_id == "" ? null : parseInt(user_id),
        balance: parseFloat(balance),
        store_id: getSelectedStoreDetails("id"),
        walk_in: walk_in ?? "",
        business: [businessFields],
      };

      console.log("        walk_in: true,", payload)

      await submit(payloadValidator(payload));
      showSwal({
        title: "Confirmation!",
        text: "Customer has been created.",
        onConfirm: () => {},
      });
      reset(defaultValues);
      refetch();
      closeModal("add-units");

      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = "";
      }
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const country = watch("business.address.country");
  const state = watch("business.address.state");

  const resetField = (field) => setValue(field, "");

  return {
    values: {
      control,
      errors,
      image: watch("image"),
      countries: getCountries(),
      states: country ? getStates(country?.country_id) : [],
      cities:
        country && state ? getCities(state.country_id, state.state_id) : [],
      business_types: general?.business_type?.map((item) => ({
        label: item,
        value: item,
      })),
    },
    functions: {
      onSubmit: handleSubmit(onAddCustomer),
      onCancel,
      resetField,
    },
  };
};

export default useCreateCustomer;
